import React from 'react';
import styled from 'styled-components';
import {FadeIn} from '../../../libs/components/FadeIn';

const AboutTitle = styled.p`
  text-decoration: underline;
  font-size: 1.25em;
  font-weight: bold;
  padding: 10px 20px 10px 20px;
`;

export default function BusinessCardAbout({about,direction,fontColor}){

    const title = direction === 'rtl' ? 'אודות' : "About";
    return (
      <FadeIn>
        <div style={{whiteSpace: "pre-wrap" , fontSize: '1.1em' , marginBottom: '20px' , marginLeft: '20px' , marginRight: '20px' , fontWeight: '100' ,color: fontColor ? fontColor : 'white' , textAlign:'center'}}>
            <AboutTitle>{title}</AboutTitle>
            {about}
        </div>
      </FadeIn>
    )
}